<template lang="pug">
  section
    the-popup
    the-ato-snackbar
    the-app-bar
    the-side-navigation
    slot
</template>

<script>
import ThePopup from "@/components/ThePopup";
import TheAtoSnackbar from '@/components/tools/TheAtoSnackbar'
import TheAppBar from "@/components/toolbars/TheAppBar";
import TheSideNavigation from '@/components/TheSideNavigation'

export default {
  components: {
    ThePopup,
    TheAtoSnackbar,
    TheAppBar,
    TheSideNavigation
  }
}
</script>